const state = {
  curTitle: '2025寒露', //埋点标题 弹窗缓存key
  // curKey: "Cs", // 弹窗缓存key
  starTime: '2025/10/08', // 弹窗开始日期 0点 测试环境不判断
  endTime: '2025/10/09', // 弹窗结束日期 0点（2024/08/22 23:59:59也行）
  popTime: 1, // 弹窗次数 1次
  bgImg: 'https://cdnvue.gymcity.com.cn/uploads/solarTerms-pos-bg?v=10', // 海报背景
  btnImg: 'https://cdnvue.gymcity.com.cn/uploads/24xspos-btn', // 海报按钮 固定
  topImg: 'https://cdnvue.gymcity.com.cn/uploads/24xspos-top' // 海报上方矩形 固定
}
const mutations = {}
const getters = {}
const actions = {}

export default {
  state,
  mutations,
  actions,
  getters
}
